module.exports = __webpack_public_path__ + "img/viessmann_wordmark_rgb_1_vitorange.00b76ae6.png";